import * as React from 'react'
import { BPMChart } from '../../../../components/Chart'
import { BPMAnalyticsAPI } from '../../../../api'

export const GenreChart: React.FunctionComponent = (props) => {
    const [total, setTotal] = React.useState(0)
    return (
        <BPMChart {...props} title='Genres' type='doughnut' subTitle={`Total of ${total} downloads`}
            onRequestLoad={(options, signal) => {
                return BPMAnalyticsAPI.get<any>('downloads/byGroup', options, signal).then((d) => {
                    setTotal(d.reduce((a, b) => a + b.count, 0))
                    return d
                })
            }} additionalParams={{ groupBy: 'genre_name' }}
            allowedTypes={['spline', 'bar', 'doughnut', 'pie', 'tree']}
            series={{
                name: 'Downloads', valueField: 'count', argumentField: 'genre_name',
                smallValuesGrouping: { topCount: 10, mode: 'topN' }
            }}>
        </BPMChart>
    )
}


// WEBPACK FOOTER //
// ./src/pages/Statistics/Downloads/charts/GenreChart.tsx